import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Form, Formik, useField, useFormikContext,
} from 'formik';

import Button from '@components/smartAdminUI/Button';

// custom input fields using Formik's useField react hook
const CustomInput = ({ label, name }) => {
  const [field, meta] = useField(name);
  return (
    <div className="form-group">
      <label className="form-label" htmlFor="inputField">{label}</label>
      <input
        className="form-control"
        {...field}
      />
      {meta.touched && meta.error ? (
        <div className="invalid-feedback">{meta.error}</div>
      ) : null}
    </div>
  );
};

CustomInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
};

const TaxAutoPopForm = props => {
  const { onSearchSubmit, formClear } = props;
  const [formEdited, setFormEdited] = useState(false);

  const taxAutoPopSearchLoading = useSelector(state => state.listing.searchLoading);

  const FormikHelper = () => {
    const { dirty, resetForm } = useFormikContext();

    useEffect(() => {
      if (dirty) {
        if (!formEdited) setFormEdited(true);
      } else {
        // eslint-disable-next-line no-lonely-if
        if (formEdited) setFormEdited(false);
      }
    }, [dirty]);

    // resets form once the tax auto pop modal reopens
    useEffect(() => {
      if (formClear) {
        if (formEdited) {
          resetForm({});
        }
      }
    }, []);

    return null;
  };

  const buildWhereClause = values => {
    const whereClause = {
      clause: [],
    };
    const valueKeys = Object.keys(values);

    valueKeys.forEach(key => {
      if (values[key]) {
        whereClause.clause.push({
          Name: key,
          Value: values[key].trim(),
        });
      }
    });
    return whereClause;
  };

  const handleSubmit = values => {
    const whereClause = buildWhereClause(values);

    const jsonBody = {
      action: 'search',
      where: whereClause,
    };
    onSearchSubmit(jsonBody);
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      validateOnMount={false}
      initialValues={{
        ParcelNumber: '',
        TaxRollNumber: '',
        UnitNumber: '',
        StreetNumber: '',
        StreetName: '',
      }}
    >
      {({
        values, resetForm,
      } = props) => (
        <Form>
          <CustomInput
            label="Linc Number"
            name="ParcelNumber"
            value={values.ParcelNumber ?? ''}
          />
          <CustomInput
            label="Roll Number"
            name="TaxRollNumber"
            value={values.TaxRollNumber ?? ''}
          />
          <CustomInput
            label="Unit Number"
            name="UnitNumber"
            value={values.UnitNumber ?? ''}
          />
          <CustomInput
            label="Street Number"
            name="StreetNumber"
            value={values.StreetNumber ?? ''}
          />
          <CustomInput
            label="Street Name"
            name="StreetName"
            value={values.StreetName ?? ''}
          />
          <Button
            name="btnSearchTaxAutopop"
            variant="primary"
            type="submit"
          >
            {taxAutoPopSearchLoading
              ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
                  Searching...
                </>
              ) : (
                <>
                  <i className="fas fa-search mr-2" aria-hidden="true" />
                  Search
                </>
              )}
          </Button>
          <Button name="btnSearchTaxAutopopClear" variant="primary" onClick={() => resetForm()} data-dismiss="modal" data-target="#taxAutoPopModal">
            <i className="fas fa-window-close mr-2" aria-hidden="true" />
            Cancel
          </Button>
          <FormikHelper />
        </Form>
      )}
    </Formik>
  );
};

TaxAutoPopForm.propTypes = {
  formClear: PropTypes.oneOf([true, false]),
  onSearchSubmit: PropTypes.func,
};

export default TaxAutoPopForm;
